/**
 * Поддерживаемые форматы изображений для превью.
 *
 * Backend specification:
 * https://a.yandex-team.ru/arcadia/videoplatform/cloud/tusd/internal/service/fileservice/thumbnails.go
 */
export const THUMBNAIL_UPLOAD_ACCEPT_MIMETYPES: string[] = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
];

export const THUMBNAIL_INPUT_ACCEPT_ATTRIBUTE = THUMBNAIL_UPLOAD_ACCEPT_MIMETYPES.join(', ');

/**
 * Максимальный размер файла превью в байтах (10 МБ)
 */
export const MAX_THUMBNAIL_SIZE = 10 * 1024 * 1024;
